import { RadioButtonOption } from "../../../common/enums";
import CounterSignatureRequest from "../../CounterSignatureRequest";
import Signature from "../../Signature";

export const ELECTRIC_FENCE_CHECKLIST_VERSION_2026_02 = 1;

export type ElectricFenceChecklist = {
    checklistVersion: number | undefined;
    portEntryIsInformedOfWork: RadioButtonOption;
    lowHighVoltageIsCut: RadioButtonOption;
    highVoltageIsGrounded: RadioButtonOption;
    workInProgressSignIsUp: RadioButtonOption;
    powerOffIsControlled: RadioButtonOption;
    securityCoordinatorInformedPermitUpdated: RadioButtonOption;
    controlledNoPersonAtFence: RadioButtonOption;
    securityRoundPerformed: RadioButtonOption;
    checkedPowerIsOn: RadioButtonOption;
    securityCoordinatorInformedPermitReturned: RadioButtonOption;

    signIsAtBreakerOrFuse: RadioButtonOption;
    powerOffWillBeControlled: RadioButtonOption;
    securityCoordinatorInformedAboutStartedWork: RadioButtonOption;
    electricianInformedPortEntryWorkComplete: RadioButtonOption;
    securityCoordinatorInformedWorkComplete: RadioButtonOption;

    powerOffResponsibleElectricianSignature: Signature;
    powerOffWorkLeaderSignature: Signature;
    powerOffDirectorFlammableProductSignature: Signature;
    powerOffPortOfficerSignature: Signature;
    powerOffExternalDirectorFlammableProductSignature: Signature;
    powerOffCounterSignatureRequest: CounterSignatureRequest;

    powerOnResponsibleElectricianSignature: Signature;
    powerOnWorkLeaderSignature: Signature;
    powerOnDirectorFlammableProductSignature: Signature;
    powerOnPortOfficerSignature: Signature;
    powerOnExternalDirectorFlammableProductSignature: Signature;
    powerOnCounterSignatureRequest: CounterSignatureRequest;
};
